// WorkAbroadIntro.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const WorkAbroadIntro = () => {
  const considerations = [
    'Clearing the eligibility and paperwork checks that come first',
    'Matching the experience level and criteria a specific role sets',
    'Knowing what the contract terms mean and how long each stage takes',
    'Getting ready to be interviewed by professionals in your field',
    'Being prepared for the move itself and for onboarding once you arrive'
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left Column - Heading and Intro */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-6">
              What Moving Abroad for Work Asks of You
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              Landing a role overseas is rarely about spotting an opening. Employers set their own bar, they expect evidence of experience that clears it, and the recruitment process itself is formal from start to finish.
            </p>
          </motion.div>

          {/* Right Column - Considerations List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="text-gray-700 text-base font-normal mb-6">
              Most candidates who get there have worked through:
            </p>
            
            <ul className="space-y-3">
              {considerations.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle size={18} className="text-gray-600 flex-shrink-0" />
                  <span className="text-gray-600 text-sm font-light">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WorkAbroadIntro;
